export let morse = (function () {
  let morseCode = {
    A: '01',
    B: '1000',
    C: '1010',
    D: '100',
    E: '0',
    F: '0010',
    G: '110',
    H: '0000',
    I: '00',
    J: '0111',
    K: '101',
    L: '0100',
    M: '11',
    N: '10',
    O: '111',
    P: '0110',
    Q: '1101',
    R: '010',
    S: '000',
    T: '1',
    U: '001',
    V: '0001',
    W: '011',
    X: '1001',
    Y: '10011',
    Z: '1100',
    '1': '01111',
    '2': '00111',
    '3': '00011',
    '4': '00001',
    '5': '00000',
    '6': '10000',
    '7': '11000',
    '8': '11100',
    '9': '11110',
    '0': '11111',
  }
  let morseCodeHash = {
    '01': 'A',
    '1000': 'B',
    '1010': 'C',
    '100': 'D',
    '0': 'E',
    '0010': 'F',
    '110': 'G',
    '0000': 'H',
    '00': 'I',
    '0111': 'J',
    '101': 'K',
    '0100': 'L',
    '11': 'M',
    '10': 'N',
    '111': 'O',
    '0110': 'P',
    '1101': 'Q',
    '010': 'R',
    '000': 'S',
    '1': 'T',
    '001': 'U',
    '0001': 'V',
    '011': 'W',
    '1001': 'X',
    '10011': 'Y',
    '1100': 'Z',
    '01111': '1',
    '00111': '2',
    '00011': '3',
    '00001': '4',
    '00000': '5',
    '10000': '6',
    '11000': '7',
    '11100': '8',
    '11110': '9',
    '11111': '0',
  }

  return {
    DI: '0',
    DA: '1',
    getLetter (text, seq = ' ') {
      if (typeof text !== 'string') return ''
      let codes = text.split(seq)
      let s = ''
      for (let i = 0; i < codes.length; ++i) {
        s += morseCodeHash[codes[i]] || ''
      }
      return s
    },

    getCode (text, seq = ' ') {
      if (typeof text !== 'string') return ''
      let s = ''
      for (let i = 0; i < text.length; ++i) {
        // console.log('mores', text[i])
        s += (morseCode[text[i].toUpperCase()] || '') + seq
      }
      return s
    }
  }
})()
